import React from 'react';
import { accountSearchColumns, donViSearchColumns, QUERY_KEYS } from '@/constants';
import { FormFieldV2, SearchFieldV2 } from '@/components/custom/erp';
import type { AccountModel, DonViCoSo } from '@/types/schemas';

interface FilterTabProps {
  formMode: 'add' | 'edit' | 'view';
}

const FilterTab = ({ formMode }: FilterTabProps) => {
  const isViewMode = formMode === 'view';

  return (
    <>
      <div className='space-y-3 p-4'>
        <div className='grid grid-cols-[150px,1fr] items-center'>
          <span className='text-left text-sm font-normal'>TK doanh thu</span>
          <SearchFieldV2<AccountModel>
            name='revenueAccount'
            searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
            searchColumns={accountSearchColumns}
            columnDisplay='code'
            displayRelatedField='name'
            dialogTitle='Danh mục tài khoản'
            disabled={isViewMode}
          />
        </div>
      </div>
      <div className='space-y-3 border-t border-gray-200 p-4'>
        <div className='grid grid-cols-[150px,1fr] items-center'>
          <span className='text-left text-sm font-normal'>Đơn vị</span>
          <SearchFieldV2<DonViCoSo>
            name='unit'
            searchEndpoint={`/${QUERY_KEYS.DON_VI_CO_SO}/`}
            searchColumns={donViSearchColumns}
            columnDisplay='ma_unit'
            displayRelatedField='ten_unit'
            dialogTitle='Danh mục đơn vị'
            disabled={isViewMode}
          />
        </div>

        <div className='grid grid-cols-[150px,1fr] items-center'>
          <span className='text-left text-sm font-normal'>Trạng thái</span>
          <FormFieldV2
            name='status'
            type='select'
            className='w-[200px]'
            options={[
              { value: 'all', label: 'Tất cả' },
              { value: 'not_posted', label: 'Chưa ghi sổ' },
              { value: 'pending', label: 'Chờ duyệt' },
              { value: 'posted', label: 'Đã ghi sổ' }
            ]}
            disabled={isViewMode}
          />
        </div>

        <div className='grid grid-cols-[150px,1fr] items-center'>
          <span className='text-left text-sm font-normal'>Lọc theo người SD</span>
          <FormFieldV2
            name='filterByUser'
            type='select'
            className='w-[200px]'
            options={[
              { value: 'all', label: 'Tất cả' },
              { value: 'created_by', label: 'Lọc theo người tạo' }
            ]}
            disabled={isViewMode}
          />
        </div>
      </div>
    </>
  );
};

export default FilterTab;
